export function isAnchorLink (url, location = window.location) {
  if ((new URL(url)).hash === '') {
    return false
  }

  const currentUrl = new URL(location.href)
  currentUrl.hash = ''

  const linkUrl = new URL(url)
  linkUrl.hash = ''

  return currentUrl.toString() === linkUrl.toString()
}
